module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm-title",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There are many people I would like to thank for making this book possible. Firstly, to Jonathan Wright from Pen & Sword for commissioning this book and giving me the platform to work on a project about such a fascinating topic. Thanks must also go to Alice Wright, Lori Jones, Charlie Simpson, Emily Robinson and Laura Hirst from Pen & Sword for their dedicated support through the writing and editing process. I owe much gratitude to my wonderful copy editor, Stephen Carver, whose incredible hard work has made this book what it is. His expertise, counsel and patience have been hugely appreciated, and he has been such a pleasure to work with.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many thanks to all those who helped me with my research or made introductions and enquiries on my behalf to people relevant to this book: Dorothy, Michael, Julian, Catherine, Peregrine, Matthew, Sarah and Henry to name a few.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is now the second time my father has had to put up with reading through early drafts of my manuscripts, and his corrections, advice and encouragement are greatly appreciated. Special thanks also to my mother for her endless support for this, and my other projects.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, I would not have been able to write this book without the constant motivation and inspiration from my wife, who has had to put up with me either being away at various archives and libraries researching, or chained to my desk writing for days on end. I cannot thank her enough for her unwavering support.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b024cd02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Acknowledgement.vue
// module id = 75
// module chunks = 0